export default function PHP_debug_zval_dump() {
  return (
    <div>
      <h1>PHP_debug_zval_dump</h1>
    </div>
  );
}
